import { render, staticRenderFns } from "./PversionTip.vue?vue&type=template&id=325bee74&scoped=true"
import script from "./PversionTip.vue?vue&type=script&lang=js"
export * from "./PversionTip.vue?vue&type=script&lang=js"
import style0 from "./PversionTip.vue?vue&type=style&index=0&id=325bee74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325bee74",
  null
  
)

export default component.exports